import HeaderOfLeaderPortal from "../../utils/HeaderOfLeaderPortal";
import {useEffect, useState} from "react";
import {
    discountCodeList,
} from "../../../api/LeaderPortalApi";
import {notify, StyleTooltip} from "../../utils";
import SearchOfLeaderPortal from "../../utils/SearchOfLeaderPortal";
import RightArrow from "../../icons/RightArrow";
import LeftArrow from "../../icons/LeftArrow";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import {PaginationItem} from "@mui/material";
import {toFarsiNumber} from "../../methods/CommonMethods";
import PlusIcon from "../../icons/PlusIcon";
import DiscountAddPopUp from "./DiscountAddPopUp";
import {Toaster} from "react-hot-toast";
import {DiscountDeletePopUp} from "./DiscountDeletePopUp";
import {DiscountResetPopUp} from "./DiscountResetPopUp";

export default function Discount() {
    const [data, setData] = useState();
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10)
    const [param, setParam] = useState("")
    const [statusTrans, setStatusTrans] = useState("NOT_USED")
    const [totalPage, setTotalPage] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [loadingPage, setLoadingPage] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [openModalClose, setOpenModalClose] = useState(false)
    const [openModalReset, setOpenModalReset] = useState(false)
    const [changeId, setChangeId] = useState("")
    const [edit, setEdit] = useState(false);

    const prevPage = () => {
        if(page > 1) {
            setPage(page - 1);
        }else{
            setPage(1)
        }
    }

    const nextPage = () => {
        if(page < totalPage) {
            setPage(page + 1)
        }else{
            setPage(totalPage)
        }
    }

    const tabFun = () => {
        setIsLoading(true)
        const searchPage = page - 1;

        discountCodeList(statusTrans, param, searchPage, size).then( response => {
            setData(response.data.content)
            setTotalPage(response.data.totalPages)
            setIsLoading(false)
        }).catch( error => {
            notify(error?.response?.data?.message)
            setIsLoading(false)
        })

    }

    useEffect( () => {
        tabFun();
    }, [page, size, statusTrans, loadingPage])

    useEffect( () => {
        setPage(1)
    }, [statusTrans, param, size])

    const exportExcel = () => {

    }

    function changeDateToFarsi(DateUTC) {

        const IranTime = new Date(DateUTC);

        IranTime.setMinutes(
            IranTime.getMinutes() +
            IranTime.getTimezoneOffset() +
            210, // Iran's time zone offset is UTC+3:30
        );

        return IranTime.toLocaleDateString('fa-IR')
    }

    const tabButtons = [
        {
            name: "کل کد تخفیف‌ها",
            statusTrans: 'ALL'
        },
        {
            name: "استفاده شده",
            statusTrans: 'USED'
        },
        {
            name: "استفاده نشده",
            statusTrans: 'NOT_USED'
        },
    ]

    const btnProps = {
        text: "کد تخفیف جدید",
        icon: <PlusIcon />,
        classN : "btn border btn_discount",
        setOpenModal: setOpenModal
    }

    return(
        <>
            <Toaster/>
            <HeaderOfLeaderPortal
                title={`کد تخفیف`}
                text={`آخرین درخواست های انصراف مشتری از دریافت گواهی را در این قسمت مشاهده می‌کنید`}
                exportFunction={exportExcel}
            />

                <SearchOfLeaderPortal
                    tabButtons={tabButtons}
                    colSize={`col-8`}
                    activeBtnName={tabButtons[2].name}
                    setSearchText={setParam}
                    searchText={param}
                    statusTrans={statusTrans}
                    setStatusTrans={setStatusTrans}
                    tabFun={tabFun}
                    btnProps={btnProps}
                    searchPlaceHolder={"جستجو: کد تخفیف، درصد تخفیف"}
                />



            <div className={`request-body-div px-4 mt-4`} style={{minHeight: "60vh"}}>
                <table className={`table table-borderless`}>

                    <thead>
                    <tr>
                        <th className={`text-center`}>کد تخفیف</th>
                        {/*<th className={`text-center`}>تخصیص</th>*/}
                        {/*<th className={`text-center`}>نوع گواهی</th>*/}
                        <th className={`text-center`}>درصد تخفیف</th>
                        <th className={`text-center`}>تاریخ شروع</th>
                        <th className={`text-center`}>تاریخ انقضا</th>
                        <th className={`text-center`}>میزان استفاده</th>
                        <th className={`text-center`}>عملیات</th>
                    </tr>

                    </thead>

                    <tbody>
                    {
                        data && data.length > 0 ?
                            (data.map((row) => (
                                <tr className={`tr_table`}>
                                    <td className={`text-center`}>{row.value}</td>
                                    <td className={`text-center`}>{row.percent}</td>
                                    <td className={`text-center`}>{ row.startTime ? changeDateToFarsi(row.startTime) : ""}</td>
                                    <td className={`text-center`}>{row.endTime ? changeDateToFarsi(row.endTime) : ""}</td>
                                    <td className={`text-center`}>
                                        <span className={`${ row.count != null && row.countUsed != null && row.count == row.countUsed ? "span-lable-red-dis" : "span-lable-green-dis"}`}>
                                            {row.count == null ? 0 : row.count} / {row.countUsed == null ? 1 : row.countUsed}
                                        </span>
                                    </td>
                                    <td className={`text-center`}>
                                        <StyleTooltip title={"ویرایش کد تخفیف"} arrow placement="top">
                                            <img
                                                className={`pointer`}
                                                src={require('../../../image/edit-icon.png')}
                                                onClick={() => {
                                                    setEdit(true)
                                                    setChangeId(row.id)
                                                    setOpenModal(true)
                                                }} />
                                        </StyleTooltip>
                                        <StyleTooltip title={"بازنشانی کد تخفیف"} arrow placement="top">
                                            <img
                                                className={`mx-3 pointer`}
                                                src={require('../../../image/refresh-icon.png')}
                                                onClick={() => {
                                                    setChangeId(row.id)
                                                    setOpenModalReset(true)
                                                }} />
                                        </StyleTooltip>
                                        <StyleTooltip title={"حذف کد تخفیف"} arrow placement="top">
                                            <img
                                                className={`pointer`}
                                                src={require('../../../image/trash-icon.png')}
                                                onClick={() => {
                                                    setChangeId(row.id)
                                                    setOpenModalClose(true)
                                                }} />
                                        </StyleTooltip>
                                    </td>
                                </tr>
                            )))
                            :
                            (<tr className={`tr_table`}>
                                <td scope={6} className={`text-center`} style={{color: "grey"}}>اطلاعاتی ثبت نشده است.</td>
                            </tr>)
                    }
                    </tbody>

                </table>
            </div>

            <div className={`row w-100 justify-content-between mt-3`}>

                <div className={`col-3 p-0`}>
                    <button className={`btn btn-sm footer-btn`} onClick={nextPage}>
                        <RightArrow />
                        بعدی</button>
                    <button className={`btn btn-sm footer-btn`} onClick={prevPage}>
                        قبلی
                        <LeftArrow />
                    </button>
                </div>

                <div className={`col-4`}>
                    <Stack spacing={2}>
                        <Pagination
                            onChange={(event, value) => setPage(value)}
                            count={totalPage}
                            page={page}
                            size="small"
                            shape="rounded"
                            variant="outlined"
                            color="primary"
                            renderItem={(item) => (
                                <PaginationItem
                                    {...item}
                                    page={item.page !== null ? toFarsiNumber(item.page) : item.page}
                                />
                            )}
                        />
                    </Stack>
                </div>

                <div className={`col-3 footer-div`}>
                    <p>تعداد نمایش در هر صفحه</p>
                    <select className="form-select" onChange={(e) => setSize(e.target.value)}>
                        <option value="10">۱۰</option>
                        <option value="25">۲۵</option>
                        <option value="100">۱۰۰</option>
                        <option value="500">۵۰۰</option>
                    </select>
                </div>

            </div>

            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

            <DiscountAddPopUp
                open={openModal}
                setOpen={setOpenModal}
                setLoadingPage={setLoadingPage}
                id={changeId}
                editable={edit}
                setEditable={setEdit}
            />

            <DiscountDeletePopUp
                open={openModalClose}
                setOpen={setOpenModalClose}
                id={changeId}
                setLoadingPage={setLoadingPage}
            />

            <DiscountResetPopUp
                open={openModalReset}
                setOpen={setOpenModalReset}
                id={changeId}
                setLoadingPage={setLoadingPage}
            />
        </>
    )
}